import ImageWithGalleryLightbox from 'components/ImageWithGalleryLightbox/ImageWithGalleryLightbox'

export default ImageWithGalleryLightbox
